// extracted by mini-css-extract-plugin
export default {"container":"FullScreenMessage_container__jknAn","ico-heart":"FullScreenMessage_ico-heart__tO7UI","heart":"FullScreenMessage_heart__EDgnC"};